import { makeStyles } from "@material-ui/core";

export const receiptConferenceStyles = makeStyles(theme => ({
  table: {
    width: "100%",
    marginTop: "1.3rem",
    [theme.breakpoints.down("md")]: {
      marginLeft: "0.5rem",
      marginRight: "0.5rem"
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0.25rem",
      marginRight: "0.25rem"
    }
  },
  title: {
    fontFamily: "Roboto",
    fontSize: "1.1rem",
    fontWeight: "500",
    color: "#757575",
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem"
    }
  }
}));

export const rowConferenceStyles = makeStyles(theme => ({
  root: {
    marginTop: "2.5rem",
    background: props => (props.index % 2 === 0 ? "#F5F6F7" : "#FFFFFF"),
    "& > *": {
      borderBottom: "unset"
    }
  },
  sellerName: {
    fontFamily: "Roboto",
    fontSize: "1rem",
    fontWeight: "500",
    color: "#000000",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem"
    }
  },
  tableCell: {
    paddingBottom: 0,
    paddingTop: 0,
    background: "#F9FCF4"
  },
  accordionContent: {
    overflowX: "auto",
    maxWidth: "100%"
  },
  subtitle: {
    fontFamily: "Roboto",
    fontSize: "0.899rem",
    fontWeight: "500",
    color: "#757575",
    lineHeight: "1rem",
    whiteSpace: "nowrap"
  },
  producName: {
    fontFamily: "Roboto",
    fontSize: "1rem",
    fontWeight: "500",
    color: "#161616",
    paddingTop: "2rem",
    paddingBottom: "2rem",
    minWidth: "120px",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.9rem",
      minWidth: "100px",
      paddingTop: "1.5rem",
      paddingBottom: "1.5rem"
    }
  },
  iconDesign: {
    cursor: "pointer"
  },
  menuPopover: {
    display: "flex",
    flexDirection: "column",
    padding: "0.5rem",
    maxWidth: "27rem",
    minWidth: "20rem",
    minHeight: "9.8rem",
    background: "#FFFFFF",
    border: "1px solid #CFCECE",
    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "8px",
    [theme.breakpoints.down("md")]: {
      maxWidth: "24rem",
      minWidth: "18rem"
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "20rem",
      minWidth: "16rem",
      minHeight: "8rem"
    }
  },
  observationText: {
    display: "flex",
    flexGrow: 1,
    padding: "0.5rem",
    position: "relative",
    width: "100%",
    wordBreak: "break-word",
    wrap: "wrap",
    fontFamily: "Roboto",
    fontSize: "1rem",
    fontWeight: 500,
    color: "#353535",
    border: "1px solid #cfcecea8",
    borderRadius: "8px",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.9rem"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.85rem",
      padding: "0.4rem"
    }
  },
  popoverAction: {
    display: "flex",
    justifyContent: "flex-end"
  }
}));
